<template>
  <div>
    <div class="container">
      <div class="col-md-3 col-lg-3">

      </div>
      <div class="panel panel-default align-center col-md-6 col-lg-6 margin-Top-6Perc">
        <div class="panel-body">
          <form action="/action_page.php">
            <div class="form-group">
              <label for="email">Old Password:</label>
              <input type="email" class="form-control" id="email">
            </div>
            <div class="form-group">
              <label for="pwd">New Password:</label>
              <input type="password" class="form-control" id="pwd">
            </div>
            <div class="form-group">
              <label for="pwd">Confirm Password:</label>
              <input type="password" class="form-control" id="pwd">
            </div>
            <div class="col-xs-offset-5 col-sm-offset-5 col-md-offset-5 col-lg-offset-5">
              <button type="submit" class="btn btn-default">Save</button>
            </div>
          </form>
        </div>
      </div>
      <div class="col-md-3 col-lg-3">

      </div>
    </div>
  </div>
</template>

<script>

export default {
  data: function () {
    return {}
  }}
</script>

<style scoped>
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-6Perc{
  margin-top: 6%;
}
</style>



// WEBPACK FOOTER //
// src/pages/ForgotPassword.vue